module.exports = __webpack_public_path__ + "img/trainingCenter-noData.b5c61369.png";